export default "function iLoveVeryLongRunOnFunctioNames(longArg1: string, anotherArg: number, tooManyArgs: boolean) {\n    console.log(\"\");\n}\n"